import * as React from "react";
import { Container, Span } from "./Styled";

type TitleProps = {
}

const Title: React.FunctionComponent<TitleProps> = ({children}) => {
  return (
    <Container>
      <Span>{children}</Span>
    </Container>
  );
};

export default Title;
